// 已知 adapter 的元信息 (v0 hardcoded, 未来从 server register msg 拉)
//
// 参考 Slack / Discord slash command 自动补全的设计:
//   - 显 id + 一行简短描述
//   - 后续可以加 usage_hints[] 做二级补全 (Enter 后弹下一级)

export interface AdapterMeta {
  id: string;
  description: string;
  /** 二级参数模板, 例: ["-p <prompt>", "exec <file>"] */
  usage?: string[];
}

const KNOWN: Record<string, AdapterMeta> = {
  echo: {
    id: "echo",
    description: "回声测试 · auto, 无需审批",
  },
  claude: {
    id: "claude",
    description: "Claude Code · 写代码 / 跑命令 · confirm-each",
    usage: ["-p <prompt>", "<file path>"],
  },
  codex: {
    id: "codex",
    description: "OpenAI Codex CLI · 代码生成 / 编辑 · confirm-each",
    usage: ["exec <file>", "chat <prompt>"],
  },
};

export function adapterMeta(id: string): AdapterMeta {
  return KNOWN[id] ?? { id, description: "（无描述, 自定义 adapter）" };
}
